"use client";
import { Button } from "primereact/button";

const NotFoundPage = () => {
  return (
    <div className="flex h-screen items-center justify-center bg-gray-100">
      <section className="page_404 w-full max-w-2xl rounded-xl">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="col-sm-10 col-sm-offset-1 text-center">
                <div className="four_zero_four_bg">
                  <h1 className="text-center">404</h1>
                </div>

                <div className="content_box_404">
                  <h3 className="h2">Look like you&apos;re lost</h3>

                  <p>the page you are looking for not avaible!</p>
                  <Button
                    onClick={() => {
                      window.location.href = "/";
                    }}
                    className="flex h-max w-max cursor-pointer items-center justify-center rounded p-1 transition-all hover:bg-gray-300"
                  >
                    Go to Home
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFoundPage;
